// extracted by mini-css-extract-plugin
export default {"pageNotAuthorized":"NotAuthorized_pageNotAuthorized__5vzrc","content":"NotAuthorized_content__uMZux","logo":"NotAuthorized_logo__zRbkG","text":"NotAuthorized_text__yyzvv"};